export enum cartStatus {
  COMPLETE = 'COMPLETE',
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

enum DiscountCodeApplicationInfoStatus {
  VALID = 'VALID',
  INVALID = 'INVALID',
  INELIGIBLE = 'INELIGIBLE',
}

interface DiscountCodeApplicationInfo {
  status: DiscountCodeApplicationInfoStatus
  discountAmount: number
}

interface CartCostSummary {
  discountCodeApplicationInfo: DiscountCodeApplicationInfo
  subTotalAmount: number
  totalDiscount: number
  totalStoreCreditGrant: number
  totalAmount: number
}

export interface Cart {
  id: string
  customerId?: string
  lineItems: CartLineItem[]
  saveForLaterItems?: CartLineItem[]
  outOfStockLineItems?: CartLineItem[]
  currencyCode: string
  discountCode?: string
  cartStatus: cartStatus
  cartCostSummary?: CartCostSummary
  createdAt: string
  updatedAt: string
}

interface CartAttribute {
  key: string
  value: string
}

export interface PromoAllocation {
  amount: number
  promoCode: string
  promoType: 'STORE_CREDIT_GRANT' | 'MONEY_DISCOUNT'
}
interface CartLineItemCostSummary {
  promoAllocations: PromoAllocation[]
  amountPerQuantity: number
  subtotalAmount?: number
  totalDiscount?: number
  totalStoreCreditGrant?: number
  totalAmount?: number
}

interface VariantMetaData {
  variantId: number
  productId: number
  price: number
  imageUrl: string
  productTitle: string
  variantTitle: string
}

export const SHIPPING_METHODS = {
  STANDARD: 'LB_STANDARD',
  SUPER: 'LB_SUPER',
  STANDARD_PREMIUM: 'LB_STANDARD_PREMIUM',
} as const

type ShippingMethods = (typeof SHIPPING_METHODS)[keyof typeof SHIPPING_METHODS]

interface BaseShippingMethod {
  name: ShippingMethods
  displayName: string
}

type ShippingMethod = BaseShippingMethod &
  (
    | {
        name: 'LB_STANDARD'
        displayName: 'STANDARD'
      }
    | {
        name: 'LB_SUPER'
        displayName: 'EXPRESS'
      }
    | {
        name: 'LB_STANDARD_PREMIUM'
        displayName: 'STANDARD_PREMIUM'
      }
  )

export interface CartLineItem {
  id: string
  variantId: number
  quantity: number
  attributes: CartAttribute[]
  costSummary?: CartLineItemCostSummary
  variantMetaData?: VariantMetaData
  createdAt: string
  updatedAt: string
  totalLineItemQuantity: number
  productMetaData?: ProductMetaData
  inventoryData?: InventoryData
  inventoryStatus?: 'IN_STOCK' | 'OUT_OF_STOCK' | 'PARTIAL_OUT_OF_STOCK'
  maxDeliveryDate?: string
  minDeliveryDate?: string
  minDaysToDelivery?: number
  maxDaysToDelivery?: number
  maxCalDays?: number
  minCalDays?: number
  fasterEdd?: boolean
  showSlowerEddMessage?: boolean
  shippingMethod?: ShippingMethod
}

interface ProductMetaData {
  svid: string | number
  spid: string | number
  productId: string | number
  options: {
    name: string
    value: string
  }[]
}

interface InventoryData {
  available: number
  tags: {
    preOrderShippingDate: string
  }
}

export interface LineItem {
  variantId: number | string
  quantity: number
  attributes: any[]
  subscriptionPlanId?: number
}

export type LineItems = LineItem[]

export interface TBuyNowApiResponse {
  buyNowCartAuthMapping: {
    id: string
    authCode: string
  }
  parentCartAuthMapping: {
    id: string
    authCode: string
  }
  buyNowCartCheckoutMapping: {
    cartId: string
    checkoutId: string
    checkoutAuthCode: string
  }
}

export interface GiftingDetails {
  recipientName: string
  recipientEmail: string
  senderName: string
  giftMessage: string
}
